import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, linkTo, linkLabel }: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 uppercase mb-2">
            <span className="w-5 h-px bg-primary-400"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">{title}</h2>
        {desc && <p className="mt-2.5 text-sm md:text-base text-foreground-600 max-w-2xl leading-7">{desc}</p>}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap shrink-0 transition-colors"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}